export function GetDefaultSelectOption() {
  return {
    value: 0,
    label: "",
  };
}
